module.exports = __webpack_public_path__ + "img/program-tfportal.5c520036.jpg";